'use client';

import { useSyncExternalStore } from 'react';

/** Mismo corte que el prefijo `sm:` de Tailwind. */
const CONSULTA = '(max-width: 639px)';

function suscribir(alCambiar: () => void) {
	if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};

	const mq = window.matchMedia(CONSULTA);
	mq.addEventListener('change', alCambiar);
	return () => mq.removeEventListener('change', alCambiar);
}

const leer = () =>
	typeof window !== 'undefined' &&
	typeof window.matchMedia === 'function' &&
	window.matchMedia(CONSULTA).matches;

/**
 * `true` en anchos de celular.
 *
 * Se usa cuando el layout no se puede resolver solo con CSS porque cambia la
 * ESTRUCTURA de los datos y no su presentación — por ejemplo, cuántos elementos
 * entran en cada página de un carrusel.
 *
 * Va por `useSyncExternalStore` y no por `useState` + `useEffect`: es estado
 * externo al árbol de React, el hook lo suscribe sin un render extra y sin
 * chocar con la regla `react-hooks/set-state-in-effect` del repo.
 *
 * En el servidor devuelve `false` a propósito: el HTML se pinta con el layout de
 * escritorio y el cliente lo corrige al montar. Así el documento servido —el que
 * ve un rastreador— siempre trae el contenido completo.
 */
export function useIsMobile() {
	return useSyncExternalStore(suscribir, leer, () => false);
}
